module.exports = __webpack_public_path__ + "img/clothing13.0dd3f809.jpg";